import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";
import { MessageCircle, Phone } from "lucide-react";

export default function CtaSection({
  title = "Hai bisogno di informazioni o vuoi prenotare un servizio?",
  lead = "Contattaci, saremo felici di aiutarti a scegliere la soluzione più adatta per il tuo animale.",
  primaryLabel = "Contattaci ora",
}) {
  return (
    <section className="py-20 sm:py-28" data-testid="cta-section">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12">
        <div className="reveal relative overflow-hidden rounded-3xl bg-[#1A1710] text-white px-8 sm:px-14 py-16 sm:py-20 grain">
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#8B4A2B]/30 blur-3xl" />
          <div className="absolute -bottom-32 -left-20 w-80 h-80 rounded-full bg-[#7A1F1F]/30 blur-3xl" />
          <div className="relative max-w-3xl">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#8B4A2B] mb-5">
              Prendiamoci cura insieme
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl leading-tight">
              {title}
            </h2>
            <p className="mt-5 text-[#E8D9AC] text-base sm:text-lg leading-relaxed">
              {lead}
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/contatti"
                data-testid="cta-contact-btn"
                className="inline-flex bg-[#8B4A2B] hover:bg-[#6B341F] text-white rounded-full px-7 py-3.5 text-sm font-semibold transition-colors"
              >
                {primaryLabel}
              </Link>
              <a
                href={SITE.whatsapp}
                target="_blank"
                rel="noreferrer"
                data-testid="cta-whatsapp-btn"
                className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur text-white rounded-full px-7 py-3.5 text-sm font-semibold transition-colors"
              >
                <MessageCircle className="w-4 h-4" /> WhatsApp
              </a>
              <a
                href={`tel:${SITE.phoneRaw}`}
                data-testid="cta-call-btn"
                className="inline-flex items-center gap-2 border border-white/30 hover:border-white text-white rounded-full px-7 py-3.5 text-sm font-semibold transition-colors"
              >
                <Phone className="w-4 h-4" /> {SITE.phoneDisplay}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
